import PelakEdit from "../../pelak-car/PelakEdit";
import styles from "./CarPlateSection.module.css";

const CarPlateSection = ({ formik }) => {

//   const {

//     values,

//     errors,

//     touched,

//     handleChange,

//     handleBlur,

// } = formik;

  return (

    <section className={styles.card}>

      <div className={styles.header}>

        <span className={styles.icon}>
          🚘
        </span>

        <div>

          <h3>
            پلاک خودرو
          </h3>

          <p>
            شماره پلاک وسیله نقلیه را وارد کنید.
          </p>

        </div>

      </div>

      <div className={styles.body}>

      <PelakEdit
          formik={formik}
      />

      </div>

    </section>

  );

};

export default CarPlateSection;